import { Avatar, Spacer } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { LinkyConsentApi } from "../../linkyConsentsAPI";

export const SidePanelHeader = (props: { driver: LinkyConsentApi }) => {
  const { firstName, lastName } = props.driver;

  return (
    <StyledPanelContainer>
      <Avatar
        size={"XL"}
        color={"mint"}
        firstName={firstName}
        lastName={lastName}
      />
      <Spacer y={1.5} />
      <StyledName>{`${firstName} ${lastName}`}</StyledName>
    </StyledPanelContainer>
  );
};

const StyledPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledName = styled.div`
  ${typographies["Header/H1"]};
  color: ${colors["colors/text/darkGrey"]};
`;
